<template>
  <AdiWidget layout="page" />
</template>

<script setup>
import { inject, onMounted } from 'vue';
import AdiWidget from '@/components/AdiWidget.vue';

const hideSidebar = inject('hideSidebar');

onMounted(() => {
  if (hideSidebar !== undefined && hideSidebar !== null) {
    hideSidebar.value = false;
  }
});
</script>
